<template>
    <section class="mt-3">
        <div
            v-if="!noCollapse"
            class="text-white font-weight-bold py-1"
            style="background-color: #323336"
        >
            <i
                class="cursor-pointer mx-2 fa fa-fw"
                :class="collapsed ? 'fa-plus' : 'fa-minus'"
                @click="toggleCollapse()"
            ></i>
            <span>{{ title }}</span>
        </div>
        <transition name="squish-vert-fade">
            <div
                v-if="!collapsed"
                class="p-3 bg-white border-light"
                :class="noCollapse ? '' : 'border-top-0'"
            >
                <h4 v-if="noCollapse" class="text-capitalize">{{ title }}</h4>
                <slot name="top"></slot>
                <div class="row">
                    <div
                        v-for="(f, i) in fields"
                        :class="
                            `col-${f.widthBase12} ${i === fields.length - 1 ? 'text-nowrap' : ''}`
                        "
                        class="text-uppercase text-muted font-weight-bold"
                    >
                        {{ f.title }}
                    </div>
                </div>
                <div class="mb-3" :class="tableClass">
                    <template v-for="d in dataSource">
                        <hr v-if="d.separator" class="bar mt-3 mb-2" />
                        <div
                            v-else=""
                            class="row hover-row"
                            :class="{
                                'cursor-not-allowed': d.cantEdit,
                                selected: selected === d.id,
                            }"
                            @click="emitEdit(d.id)"
                        >
                            <template v-if="loading">
                                <div
                                    v-for="f in fields"
                                    :class="[
                                        `col-${f.widthBase12}`,
                                        'd-flex justify-content-center align-items-center',
                                    ]"
                                >
                                    <i class="fa fa-fw fa-spin fa-circle-o-notch text-muted"></i>
                                </div>
                            </template>
                            <template v-else="">
                                <template v-for="f in fields">
                                    <div
                                        :class="[
                                            `col-${f.widthBase12}`,
                                            f.bool ? 'd-flex justify-content-center' : '',
                                            f.class,
                                            f.rowClass,
                                        ]"
                                    >
                                        <span v-if="f.type === 'bool'" class="form-check">
                                            <i
                                                class="fa fa-fw"
                                                :class="d[f.prop] ? 'fa-check' : 'fa-times'"
                                            ></i>
                                        </span>
                                        <span v-else-if="f.type === 'date'">
                                            {{
                                                d[f.prop]
                                                    ? moment(d[f.prop]).format("MM/DD/YYYY")
                                                    : "none"
                                            }}
                                        </span>
                                        <span v-else-if="f.type === 'select-multiple'">
                                            <template v-if="f.options">
                                                <template
                                                    v-if="d[f.prop].length === f.options.length"
                                                >
                                                    All ({{ f.options.length }}) entries selected
                                                </template>
                                                <template v-else="">
                                                    <template v-if="summarize">
                                                        <details>
                                                            <summary
                                                                @click.stop="stopPropagation()"
                                                            >
                                                                <span class="cursor-pointer"
                                                                    >{{ d[f.prop].length }} entries
                                                                    selected</span
                                                                >
                                                            </summary>
                                                            <span
                                                                class="comma-list small"
                                                                v-for="selectedOption in d[f.prop]"
                                                            >
                                                                {{
                                                                    f.options.find(
                                                                        l =>
                                                                            l.value ===
                                                                            selectedOption
                                                                    )
                                                                        ? f.options.find(
                                                                              l =>
                                                                                  l.value ===
                                                                                  selectedOption
                                                                          ).title
                                                                        : ""
                                                                }}
                                                            </span>
                                                        </details>
                                                    </template>
                                                    <template v-else="">
                                                        <span
                                                            class="comma-list"
                                                            v-for="selectedOption in d[f.prop]"
                                                        >
                                                            {{
                                                                f.options.find(
                                                                    l => l.value === selectedOption
                                                                )
                                                                    ? f.options.find(
                                                                          l =>
                                                                              l.value ===
                                                                              selectedOption
                                                                      ).title
                                                                    : ""
                                                            }}
                                                        </span>
                                                    </template>
                                                </template>
                                            </template>

                                            <span
                                                v-else=""
                                                class="comma-list"
                                                v-for="selectedOption in d[f.prop]"
                                                >{{ selectedOption }}</span
                                            >
                                        </span>
                                        <span v-else-if="f.displayProp">
                                            <span
                                                class="comma-list"
                                                v-for="displayProp in f.displayProp"
                                            >
                                                {{ d[displayProp] }}
                                            </span>
                                        </span>
                                        <span v-else="">
                                            {{ d[f.prop] ? f.prefix : "" }} {{ d[f.prop] }}
                                            {{ d[f.prop] ? f.suffix : "" }}
                                        </span>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
                <slot name="bottom"></slot>
                <errors :errors="widgetErrors"></errors>
            </div>
        </transition>
    </section>
</template>

<script>
import Errors from "./ErrorList";
export default {
    name: "TableInputWidget",
    components: { Errors },
    props: [
        "noCollapse",
        "loading",
        "tableClass",
        "title",
        "dataSource",
        "fields",
        "endpoint",
        "widgetErrors",
        "summarize",
        "noSelected",
    ],
    data() {
        return {
            selected: null,
            collapsed: false,
        };
    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        },
        emitDelete(id) {
            this.$emit("delete", id);
        },
        emitEdit(id) {
            if (!this.noSelected) {
                this.selected = id;
            }
            this.$emit("edit", id);
        },
        stopPropagation() {},
        resetSelected() {
            this.selected = null;
        },
    },
};
</script>

<style scoped lang="scss">
.hover-delete,
.hover-edit {
    color: #6c757d;
}
.hover-delete:hover {
    color: #dc3545;
}
.hover-edit:hover {
    color: #ffc107;
}
.hover-row:hover {
    cursor: pointer;
    background: rgba(214, 69, 113, 0.1);
}
.selected,
.selected:hover {
    background: #d64571;
    color: white;
}
</style>
